import { render, staticRenderFns } from "./damaoqi.vue?vue&type=template&id=324e8c61&scoped=true&"
import script from "./damaoqi.vue?vue&type=script&lang=js&"
export * from "./damaoqi.vue?vue&type=script&lang=js&"
import style0 from "./damaoqi.vue?vue&type=style&index=0&id=324e8c61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324e8c61",
  null
  
)

export default component.exports